import { render, staticRenderFns } from "./CapturaDocumentosConfirmacaoDados.vue?vue&type=template&id=2ac4ecd4&scoped=true&"
import script from "./CapturaDocumentosConfirmacaoDados.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosConfirmacaoDados.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosConfirmacaoDados.vue?vue&type=style&index=0&id=2ac4ecd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4ecd4",
  null
  
)

export default component.exports